<script setup lang="ts">
import { useStayStore } from '../../stores/stayStore';

const store = useStayStore();

defineEmits<{
  (e: 'submit'): void;
}>();
</script>

<template>
  <div class="login-form">
    <div class="input-group">
      <label for="booking-number">Buchungsnummer</label>
      <input
        id="booking-number"
        v-model="store.bookingNumber"
        type="text"
        placeholder="Ihre Buchungsnummer"
        class="form-input"
      />
    </div>
    <div class="input-group">
      <label for="last-name">Nachname</label>
      <input
        id="last-name"
        v-model="store.lastName"
        type="text"
        placeholder="Ihr Nachname"
        class="form-input"
      />
    </div>
    <button
      :disabled="!store.bookingNumber || !store.lastName || store.isLoading"
      @click="$emit('submit')"
    >
      {{ store.isLoading ? 'Wird angemeldet...' : 'Anmelden' }}
    </button>
    <div v-if="store.error" class="error">
      {{ store.error }}
    </div>
  </div>
</template>

<style scoped>
.login-form {
  background: white;
  padding: 1.5rem;
  margin: 1rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.input-group {
  margin-bottom: 1rem;
}

label {
  display: block;
  margin-bottom: 0.5rem;
  color: #333;
  font-weight: 500;
}

button {
  width: 100%;
  padding: 1rem;
  background: #960040;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
}

button:hover:not(:disabled) {
  background: #7d0035;
}

button:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.error {
  color: #dc2626;
  margin-top: 1rem;
  text-align: center;
}
</style>